var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';

import { settingsModel } from '../../../models/service/settings.model';
import { errorModel } from '../../../models/service/error.model';
import { alertModel } from '../../../models/core/alert.model';
import { loginModel } from '../../../models/auth/login.model';
import { controlModel } from '../../../models/core/control.model';
import { homeModel } from '../../../models/core/home.model';
import { weatherModel } from '../../../models/service/weather.model';
import { setAlertToJump } from '../../../actions/alert.actions';
import * as modalActions from '../../../actions/modal.actions';

import { REFRESH_TIMEOUT_10_SEC, REFRESH_TIMEOUT_60_SEC } from '../../../constants/data.constant';
import { CONNECT_SHOW_LAST_ALERTS_COUNT, alertsDataDirection as direction } from '../../../services/core/alerts/alerts.constant';
import { dateToTst } from '../../../utils/helpers';
import { errors, getDetails, getDetailsMaxDate } from '../../../services/core/alerts/alert.selectors';

let timerId = null;
let devicesChartDataTimerId = null;
let homeStatusTimerId = null;
let weatherStatusTimerId = null;

export class HomeContainerCore extends Component {

    constructor(props) {
        super(props);

        this.handleAlertsToggle = groupedItem => {
            const index = this.state.alertsToggled.indexOf(groupedItem.index);
            if (index < 0) {
                this.setState({
                    alertsToggled: [...this.state.alertsToggled, groupedItem.index]
                });
            } else {
                this.setState({
                    alertsToggled: [...this.state.alertsToggled.slice(0, index), ...this.state.alertsToggled.slice(index + 1)]
                });
            }
        };

        this._loadErrors = () => {
            this.props.handleGetErrors();
        };

        this._loadFull = () => {
            this._refreshLoadPrev();
            if (this.props.isAuth && !this.props.details.isLoading) {
                this.setState({
                    restAPICallTst: dateToTst(new Date())
                });
                this.props.handleGetDetails({
                    date: this.props.maxDate,
                    alertsDataDirection: direction.UP_DOWN
                });
            }
        };

        this._refreshLoadPrev = (pause = REFRESH_TIMEOUT_10_SEC) => {
            clearTimeout(timerId);
            timerId = setTimeout(this._loadFull, pause);
        };

        this._loadChartData = () => {
            this._refreshLoadChartData();
            if (this.props.controlsData.items.length) {
                this.props.handleGetBatchData([!this.props.controlsData.power.isLoading && {
                    apiFunc: controlModel.apiGetDevicesPowerSum,
                    processFunc: controlModel.processGetDevicesPowerSum,
                    params: { items: this.props.controlsData.items },
                    errorFunc: controlModel.requestGetDevicesPowerSum
                }, {
                    apiFunc: controlModel.apiGetDevicesPowerLimits,
                    processFunc: controlModel.processGetDevicesPowerLimits
                    // errorFunc: controlModel.requestGetDevicesPowerSum
                }]);
            }
        };

        this._refreshLoadChartData = (pause = REFRESH_TIMEOUT_10_SEC) => {
            clearTimeout(devicesChartDataTimerId);
            devicesChartDataTimerId = setTimeout(this._loadChartData, pause);
        };

        this._loadHomeStatus = () => {
            this._refreshLoadHomeStatus();
            if (!this.props.homeData.homeStatus.isLoading) {
                this.props.handleGetHomeStatus();
            }
        };

        this._refreshLoadHomeStatus = (pause = REFRESH_TIMEOUT_10_SEC) => {
            clearTimeout(homeStatusTimerId);
            homeStatusTimerId = setTimeout(this._loadHomeStatus, pause);
        };

        this._loadWeatherStatus = () => {
            this._refreshLoadWeatherStatus();
            if (!this.props.weatherData.weatherStatus.isLoading) {
                this.props.handleGetWeatherStatus();
            }
        };

        this._refreshLoadWeatherStatus = (pause = REFRESH_TIMEOUT_60_SEC) => {
            clearTimeout(weatherStatusTimerId);
            weatherStatusTimerId = setTimeout(this._loadWeatherStatus, pause);
        };

        this.handleToggleModal = (type, data) => {
            this.props.modalActions.toggleModal({ type, data });
        };

        this.state = {
            restAPICallTst: dateToTst(new Date()),
            alertsToggled: []
        };
    }

    componentDidMount() {
        this._loadErrors();
        this._loadFull();
        this._loadChartData();
        this._loadHomeStatus();
        this._loadWeatherStatus();
    }

    componentWillUnmount() {
        clearTimeout(timerId);
        timerId = null;

        clearTimeout(devicesChartDataTimerId);
        devicesChartDataTimerId = null;

        clearTimeout(homeStatusTimerId);
        homeStatusTimerId = null;

        clearTimeout(weatherStatusTimerId);
        weatherStatusTimerId = null;
    }

    componentDidUpdate(prevProps, prevState) {
        // because of isAuth setted after redirect is fired
        if (!prevProps.isAuth && this.props.isAuth) {
            this._loadFull();
        }

        if (!prevProps.controlsData.items.length && this.props.controlsData.items.length) {
            this._loadChartData();
        }
    }

    render() {
        return null;
    }
}

export const mapStateToPropsCore = (state, props) => {
    const { details } = getDetails(state, CONNECT_SHOW_LAST_ALERTS_COUNT);
    const maxDate = getDetailsMaxDate(state, CONNECT_SHOW_LAST_ALERTS_COUNT);

    return {
        alertModel,
        controlsData: state.control[controlModel.MODEL_NAME],
        homeData: state.home[homeModel.MODEL_NAME],
        weatherData: state.weather[weatherModel.MODEL_NAME],
        settings: state.settings[settingsModel.MODEL_NAME],
        isAuth: state.auth[loginModel.MODEL_NAME].isAuth,
        isErrors: errors(state).isNetworkError,
        maxDate,
        details
    };
};

export const mapDispatchToPropsCore = (modelGet, apiGetBatchData, apiGetHomeStatus, apiGetWeatherStatus) => dispatch => {
    return {
        modalActions: bindActionCreators(_extends({}, modalActions), dispatch),
        handleGetErrors: bindActionCreators(modelGet(errorModel), dispatch),
        handleClearErrors: bindActionCreators(errorModel.actionClear.bind(null, errorModel), dispatch),
        handleGetBatchData: bindActionCreators(apiGetBatchData, dispatch),
        handleGetHomeStatus: bindActionCreators(apiGetHomeStatus, dispatch),
        handleGetWeatherStatus: bindActionCreators(apiGetWeatherStatus, dispatch),
        handleGetDetails: bindActionCreators(modelGet(alertModel), dispatch),
        handleClearDetails: bindActionCreators(alertModel.actionClear.bind(null, alertModel), dispatch),
        handleSetAlertToJump: bindActionCreators(setAlertToJump, dispatch)
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/containers/pages/core/Home.container.js